import Icon from "@/icons";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectLabel,
    SelectTrigger,
    SelectValue,
  } from "@/components/ui/select"
  
export default function Setuppplications({ questionss }: { questionss: any }) {
    const { teamId } = useParams();

    const [description, setDescription] = useState(questionss.data.teamDescription || "");
    const [questions, setQuestions] = useState<any[]>(
        questionss.data.questions || [
            {
                question: "Why do you want to join?",
                type: "textarea"
            }
        ]
    );
    const [isPreview, setIsPreview] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const addQuestion = () => {
        if (questions.length < 10) {
            setQuestions(prev => [
                ...prev,
                {
                    id: prev.length + 1,
                    question: "",
                    type: "textarea"
                }
            ]);
        }
    };

    const updateQuestion = (index: number, field: string, value: any) => {
        const updatedQuestions = questions.map((question, i) =>
            i === index ? { ...question, [field]: value } : question
        );
        setQuestions(updatedQuestions);
    };

    const deleteQuestion = (index: number) => {
        setQuestions(prev => prev.filter((_, i) => i !== index));
    };

    useEffect(() => {
        const hasDescription = description.trim() !== "";
        const allQuestionsFilled = questions.every(q => q.question.trim() !== "");
        const specifiedQuestions = questions.length >= 1;
        setIsValid(hasDescription && allQuestionsFilled && specifiedQuestions);
    }, [description, questions]);

    const submitApplicationQuestions = async () => {
        const response = await fetch(`__SITE_BASE__/api/v1/teams/${teamId}/applications`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                description,
                questions
            })
        });

        if (response.ok) questionss.refetch();
    }

    return (
        <>

            <div className="flex flex-col gap-2 sm:p-2 py-6 w-full px-4">
                <div className="items-start flex flex-col px-2 sm:px-32 rounded-lg bg-brand-default">
                    <div className="flex justify-between gap-2 p-2 w-full">
                        <h1 className="text-white text-lg px-4 py-2 font-bold">
                            Setup your application questions
                        </h1>
                        <div className="flex max-h-12">
                            <button
                                className={`border-brand-green border-2 px-4 py-2 ${!isPreview ? 'bg-brand-darkest text-brand-green' : 'bg-transparent text-white'} rounded-l-lg`}
                                onClick={() => setIsPreview(false)}
                            >
                                Edit
                            </button>
                            <button
                                className={`border-brand-green border-2 px-4 py-2 ${isPreview ? 'bg-brand-darkest text-brand-green' : 'bg-transparent text-white'} rounded-r-lg`}
                                onClick={() => setIsPreview(true)}
                            >
                                Preview
                            </button>
                        </div>
                    </div>

                    {!isPreview ? (
                        <>
                            <div className="flex flex-col gap-2 p-2 py-2 w-full">
                                <div className="flex flex-col gap-2 p-2 rounded-lg">
                                    <div className="flex flex-col gap-2 p-2">
                                        <label className="text-gray-300 font-semibold">
                                            Description
                                        </label>
                                        <textarea
                                            className="w-full rounded-lg h-32 px-2 py-4 overflow-y-hidden bg-brand-darkest text-gray-300 focus:outline-none resize-none leading-none"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            placeholder="What's your team about?"
                                        />
                                    </div>
                                </div>
                            </div>

                            <hr className="border-gray-700" />

                            <div className="flex flex-col gap-2 p-2 py-2 w-full">
                                {questions.map((q, index) => (
                                    <div key={index} className="group flex flex-col gap-2 p-2 rounded-lg">
                                        <div className="flex flex-col gap-2 p-2">
                                            <label className="text-gray-300 font-semibold">
                                                Question {index + 1}
                                            </label>
                                            <div className="flex items-center max-h-12">
                                                <input
                                                    className={`w-full px-2 py-4 h-12 rounded-l-xl bg-brand-darkest text-gray-300 focus:outline-none resize-none leading-none`}
                                                    value={q.question}
                                                    onChange={(e) => updateQuestion(index, "question", e.target.value)}
                                                    placeholder="Enter your question here"
                                                    maxLength={100}
                                                />
                                                <div className="w-48">
                                                <Select onValueChange={(value) => updateQuestion(index, "type", value)} value={q.type}>
                                                    <SelectTrigger className="bg-brand-profile border-none rounded-r-xl h-12">
                                                        <button className="ml-2 h-full text-gray-300">
                                                            <SelectValue>{q.type === "textarea" ? "Long Answer" : "Short Answer"}</SelectValue>
                                                        </button>
                                                    </SelectTrigger>
                                                    <SelectContent className=" bg-brand-profile rounded-xl border-none py-0 text-gray-300 focus:outline-none resize-none leading-none">
                                                        <SelectGroup className="py-0 px-0">
                                                            <SelectItem value="textarea" defaultChecked={true}>
                                                                <SelectLabel>Long Answer</SelectLabel>
                                                            </SelectItem>
                                                            <SelectItem value="text">
                                                                <SelectLabel>Short Answer</SelectLabel>
                                                            </SelectItem>
                                                        </SelectGroup>
                                                    </SelectContent>
                                                </Select>
                                                </div>
                                                <button
                                                    className="ml-2 hidden group-hover:flex text-red-500"
                                                    onClick={() => deleteQuestion(index)}
                                                >
                                                    <Icon name="delete" size="20" color="#a3a3ac" />
                                                </button>
                                            </div>
                                        </div>
                                        <hr className="border-gray-700" />
                                    </div>
                                ))}

                                {questions.length < 10 && (
                                    <div className="items-center flex justify-center flex-col">
                                        <div className="flex items-center justify-center my-4 w-full cursor-pointer" onClick={addQuestion}>
                                            <div className="flex-grow border-t border-gray-700"></div>
                                            <div className="text-white ml-2 mr-2">
                                                <Icon name="plus" size="20" color="#a3a3ac" />
                                            </div>
                                            <div className="flex-grow border-t border-gray-700"></div>
                                        </div>
                                        <h1 className="text-gray-300 font-semibold">
                                            Add Question
                                        </h1>
                                    </div>
                                )}
                            </div>

                            <div className="flex w-full justify-center p-4">
                                <button
                                    className={`bg-brand-green w-full text-center px-6 py-3 rounded-lg text-white font-semibold hover:bg-green-600 disabled:opacity-50`}
                                    disabled={!isValid}
                                    onClick={() => {
                                        if (isValid) submitApplicationQuestions()
                                    }}
                                >
                                    Save
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="flex flex-col gap-2 p-2 py-2 w-full">
                                <div className="flex flex-col gap-2 p-2">
                                    <div className="flex flex-col gap-2 p-2 ">
                                        <label className="text-gray-300 font-semibold">
                                            Description
                                        </label>
                                        <div className="w-full h-32 px-2 py-4 bg-brand-dark rounded-lg text-gray-300 leading-none">
                                            {description || "What's your team about?"}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <hr className="border-gray-700" />

                            <div className="flex flex-col gap-2 p-2 py-2 w-full">
                                {questions.map((q, index) => (
                                    <div key={q.id} className="flex flex-col gap-2 p-2 rounded-lg">
                                        <div className="flex flex-col gap-2 p-2">
                                            <label className="text-gray-300 font-semibold">
                                                Question {index + 1}
                                            </label>
                                            <div className="w-full px-2 py-4 bg-brand-dark rounded-xl text-gray-300 leading-none">
                                                {q.question || "Enter your question here"}
                                            </div>
                                        </div>
                                        <hr className="border-gray-700" />
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>

        </>
    );
}
